import { render } from "./FulfilledItems.vue?vue&type=template&id=288e20de&scoped=true&ts=true"
import script from "./FulfilledItems.vue?vue&type=script&lang=ts"
export * from "./FulfilledItems.vue?vue&type=script&lang=ts"

import "./FulfilledItems.vue?vue&type=style&index=0&id=288e20de&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288e20de"]])

export default __exports__